import { environment } from 'src/environments/environment';

export class PathConstant {
  public static readonly HANDSET_LIST_PAGE = '/handset-list';
  public static readonly VALIDATE_CUSTOMER_PAGE = '/validate-customer';
  public static readonly MOBILE_NUMBER_PAGE = '/mobile-number';
  public static readonly CUSTOMER_INFO_PAGE = '/customer-info';
  public static readonly PRODUCT_SELLING_PAGE = '/product-selling';
  public static readonly CART_PAGE = '/cart';
  public static readonly CONTRACT_PAGE = '/contract';
  public static readonly SIGN_CONTRACT_PAGE = '/sign-contract';
  public static readonly GEN_QUEUE_PAGE = '/gen-queue';
  public static readonly SUCCESS_QUEUE_PAGE = '/success-queue';
  public static readonly LIST_NUMBER = '/list-number';
  public static readonly PAYMENT_METHOD = '/payment-method';
  public static readonly CAPTURE_ID_CARD = '/capture-id-card';
  public static readonly SALE_PORTAL_PAGE = '/newlogin/callback-signin';
  // public static readonly SALE_PORTAL_PAGE_OLD_PAGE = environment.SALE_PORTAL_PAGE_OLD_PAGE;
  public static readonly STOCK_PAGE = '/stock';
  public static readonly SUCCESS_PARTNER_PAGE = '/recorded-sales';
  public static readonly SERVICE_CARE = '/service-care';
  public static readonly READ_CARD = '/read-id-card';
  public static readonly WEB_SOCKET_URL = 'wss://localhost:8088';
}
